export default () => window.scrollTo(0, 0);
